<template>
  <v-container class="pa-0"  fluid>
    <component :is="routeItems[activeRoute].component" class=""></component>
  </v-container>
</template>

<script>
import { authRoute } from '@/router/routeRole'
import JournalReceived from '@/views/journal/journalReceived/JournalReceived.vue'
import CheckingInJournal from '@/views/journal/checkingJournal/CheckingInJournal.vue'
import CheckingInJournalForm from '@/views/journal/checkingJournal/CheckingInJournalForm.vue'
import AdminJournalReceivedForm from '@/views/journal/journalReceived/AdminJournalReceivedForm.vue'
import JournalNotification from '@/views/journal/journalNotification/JournalNotification.vue'
import JournalNotificationView from '@/views/journal/journalNotification/JournalNotificationView.vue'
import RegistryMessages from '@/views/journal/registryMessages/RegistryMessages.vue'

export default {
  name: 'JournalTab',
  data() {
    return {
      selectedTab: null,
    }
  },
  computed: {
    routeItems() {
      return [
        {
          title: 'Gautų dokumentų žurnalas',
          route: 'journalReceived',
          component: JournalReceived,
        },
        {
          title: 'Dokumento peržiūra / tvarkymas',
          route: 'adminJournalReceivedForm',
          component: AdminJournalReceivedForm,
        },
        {
          title: 'Siunčiamų dokumentų žurnalas',
          route: 'journalNotification',
          component: JournalNotification,
        },
        {
          title: 'Dokumento peržiūra',
          route: 'adminJournalNotificationView',
          component: JournalNotificationView,
        },
        {
          title: 'Registro pranešimai',
          route: 'registryMessages',
          component: RegistryMessages,
        },
        {
          title: 'Nepatikrintų dokumentų žurnalas',
          route: 'checkingJournal',
          component: CheckingInJournal,
        },
         {
          title: 'Nepatikrintų dokumentų žurnalas',
          route: 'journalCheckingForm',
          component: CheckingInJournalForm,
        },
      ]
    },
    tabItems() {
      return this.routeItems.filter((item) => {
        return !item.hide && authRoute(item.route)
      })
    },
    activeTab: {
      set(value) {
        this.selectedTab = value
      },
      get() {
        return this.tabItems.findIndex(function (item, index) {
          return this.$route.matched.find((element) => {
            if (item.route === element.name) {
              return true
            }
          })
        }, this)
      },
    },
    activeRoute() {
      return this.routeItems.findIndex(function (item, index) {
        if (item.route === this.$route.name) {
          return true
        }
      }, this)
    },
  },
  created() {
    this.selectedTab = this.activeTab
  },
  methods: {
    gotoTab(item) {
      if (this.$route.name !== item.route) {
        this.$router.push({
          name: item.route,
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped></style>
